import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './ProductsPage.css';
import { categorias } from '../data/products';
import FichaTecnica from '../components/FichaTecnica';

function ProductsPage() {
  const { categoriaId } = useParams();
  const navigate = useNavigate();
  const [categoriaActiva, setCategoriaActiva] = useState(null);
  const [productoModal, setProductoModal] = useState(null);

  useEffect(() => {
    if (categoriaId) {
      const cat = categorias.find(c => c.id === categoriaId);
      setCategoriaActiva(cat || null);
      // Scroll al título de la sección luego del render
      setTimeout(() => {
        const header = document.querySelector('.categoria-header');
        if (header) {
          const offset = 90; // altura del header fijo
          const top = header.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top, behavior: 'smooth' });
        }
      }, 50);
    } else {
      setCategoriaActiva(null);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [categoriaId]);

  const handleCategoriaClick = (id) => {
    navigate(`/productos/${id}`);
  };

  const handleVerTodas = () => {
    navigate('/productos');
  };

  return (
    <div className="products-page">
      {/* Modal ficha técnica */}
      {productoModal && (
        <FichaTecnica
          producto={productoModal}
          onClose={() => setProductoModal(null)}
        />
      )}

      {/* Hero */}
      <div className="products-hero">
        <div className="container">
          <h1>Nuestras Máquinas</h1>
          <p>Equipos fabricados en Argentina para panaderías que buscan producir más y mejor.</p>
        </div>
      </div>

      <div className="products-layout container">
        {/* Sidebar de categorías */}
        <aside className="categories-sidebar">
          <h3>Categorías</h3>
          <ul>
            <li>
              <button
                className={!categoriaActiva ? 'active' : ''}
                onClick={handleVerTodas}
              >
                Todos los productos
              </button>
            </li>
            {categorias.map(cat => (
              <li key={cat.id}>
                <button
                  className={categoriaActiva?.id === cat.id ? 'active' : ''}
                  onClick={() => handleCategoriaClick(cat.id)}
                >
                  {cat.nombre}
                  <span className="cat-count">{cat.productos.length}</span>
                </button>
              </li>
            ))}
          </ul>
        </aside>

        {/* Contenido principal */}
        <main className="products-main">
          {categoriaActiva ? (
            <section className="categoria-section">
              <div className="categoria-header">
                <button className="back-btn" onClick={handleVerTodas}>
                  ← Todas las categorías
                </button>
                <h2>{categoriaActiva.nombre}</h2>
                <p>{categoriaActiva.descripcion}</p>
              </div>
              <div className="products-grid">
                {categoriaActiva.productos.length > 0 ? (
                  categoriaActiva.productos.map(producto => (
                    <ProductCard
                      key={producto.id}
                      producto={producto}
                      onVerFicha={() => setProductoModal(producto)}
                    />
                  ))
                ) : (
                  <p className="empty-category">Productos próximamente.</p>
                )}
              </div>
            </section>
          ) : (
            categorias.map(cat => (
              <section key={cat.id} className="categoria-section">
                <div className="products-grid">
                  {cat.productos.length > 0 ? (
                    cat.productos.slice(0, 4).map(producto => (
                      <ProductCard
                        key={producto.id}
                        producto={producto}
                        onVerFicha={() => setProductoModal(producto)}
                      />
                    ))
                  ) : (
                    <p className="empty-category">Productos próximamente.</p>
                  )}
                </div>
              </section>
            ))
          )}
        </main>
      </div>
    </div>
  );
}

function ProductCard({ producto, onVerFicha }) {
  const [imgError, setImgError] = React.useState(false);

  return (
    <div className="product-card-catalog">
      <div className="product-card-img">
        {!imgError ? (
          <img
            src={producto.imagen}
            alt={producto.nombre}
            onError={() => setImgError(true)}
          />
        ) : null}
        <div className="img-placeholder" style={{ display: imgError ? 'flex' : 'none' }}>
          <span>{producto.modelo}</span>
        </div>
      </div>
      <div className="product-card-body">
        <span className="product-modelo">{producto.modelo}</span>
        <h3>{producto.nombre}</h3>
        <div className="product-card-actions">
          {producto.ficha ? (
            <button className="btn-ficha" onClick={onVerFicha}>
              Ver ficha técnica
            </button>
          ) : (
            <a
              href="https://wa.me/5491140882236"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-consulta"
            >
              Consultar
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

export default ProductsPage;
